import React from 'react'
import cn from 'classnames'
import { Dropdown, DropdownContent, DropdownToggle } from '@mc/design-system'
import HamburgerIcon from './assets/hamburgerIcon.svg'
import classes from './Menu.module.scss'

const Menu = ({
  ariaLabel,
  label,
  className,
  children,
  onToggle,
}: {
  ariaLabel?: string
  label?: string
  className?: string
  children?: React.ReactNode
  onToggle?: () => void
}) => (
  <Dropdown placement='bottom-end' fixed>
    <DropdownToggle>
      <button
        aria-label={ariaLabel}
        className={cn('mc-clickable mc-py-2', classes.item, className)}
        onClick={onToggle}
      >
        <div className='d-flex align-items-center'>
          {label && (
            <h6 className='mc-text-h6 mc-text--capitalize mc-pr-1 d-none d-lg-block'>
              {label}
            </h6>
          )}
          <HamburgerIcon className='mc-icon mc-icon--3' />
        </div>
      </button>
    </DropdownToggle>
    <DropdownContent appendToBody={false} className={classes.menu}>
      {children}
    </DropdownContent>
  </Dropdown>
)

export default Menu
